<div class="grid">
  <ng-template [ngIf]="isLoading">
    <app-loading></app-loading>
</ng-template>
  <div class="col-12 p-2 text-xl text-left font-['Poppins']"
    style="color: cadetblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <span class="text-xl text-left font-['Poppins'] mr-3 font-semibold" style="color: cadetblue;">Pratiche Bando 1</span>
      <div class="p-2" style="border-radius: 10px; background-color: #619496; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span 
          class="text-right font-['Poppins']" 
          style="color: #f9f9f9; font-size: small;"
          [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
          [pTooltip]="isPresidioTIM ? '' : 'Mostra tutte le pratiche del bando 1'"
          (click)="isPresidioTIM ? null : openAllPraticheFase2(1)"
        >Totali: <span class="font-semibold" style="font-size: medium;">{{stats.bando1Fase2}}</span></span>
      </div>
      <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;cursor: pointer;"
          pTooltip="Mostra le pratiche in lavorazione" tooltipPosition="top" (click)="openPraticheFase2InLavorazione(1)"> {{ isPresidioTIM ? 'In carico Presidio' : 'In lavorazione:' }} 
          <span class="font-semibold" style="font-size: medium;">{{stats.bando1Fase2InLavorazione}}</span>
        </span>
     </div>
    </div>
    <div class="flex justify-end md:justify-end">
      <button *ngIf="!isPM && !this.isImpresa && !this.isPresidioTIM && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-reply pi-cloud-upload"
          pTooltip="Aggiorna le pratiche verificate dal supporto" tooltipPosition="top"
          class="font-['Poppins'] mr-2"
          style="background-color:#ffffff; color: #3b6567; border-color: #3b6567; font-size: 13px;"
          label="Carica File TIM Support"
          (click)="importaEsitiSupporto()" [disabled]="isLoadingResults || isDemo"
        ></button>
    <button *ngIf="!isImpresa && !isPM && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-reply"
          pTooltip="Carica gli esiti della consegna ad Infratel" tooltipPosition="top"
          class="font-['Poppins'] "
          style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
          label="Carica Esiti"
          (click)="importaEsitiConsegnaAdInfratel()" [disabled]="isLoading || isDemo"
      ></button>
    </div>
    
  </div>
  <div class="col-12 grid mt-1 mb-1">
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #F3FAFD; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.1 Senza documentazione</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; color: #1C56AC;"
              [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
              [pTooltip]="isPresidioTIM ? '' : 'Apri Pratiche Senza Documentazione'"
              (click)="isPresidioTIM ? null : openPraticheFase2(1,1)"
          >insert_page_break</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_1}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
             <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 6'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,1,6)">LOTTO 6: <span class="text-l">{{stats.bando1Fase2_1_lotto6}}</span>
            </div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,1,7)">LOTTO 7: <span class="text-l">{{stats.bando1Fase2_1_lotto7}}</span>
        </div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9 ; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;  font-size: 0.7rem;text-align: left;">2.2 Documentaz. incompleta</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; color: #1C56AC"
              [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
              [pTooltip]="isPresidioTIM ? '' : 'Apri Pratiche con documentazione incompleta'"
              (click)="isPresidioTIM ? null : openPraticheFase2(1,2)"
            >inactive_order</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_2}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 6'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,2,6)">LOTTO 6: <span class="text-l">{{stats.bando1Fase2_2_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,2,7)">LOTTO 7: <span class="text-l">{{stats.bando1Fase2_2_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.3 Da Caricare</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
              pTooltip="Apri pratiche da caricare"
              (click)="openPraticheFase2(1,3)">upload_file</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_3}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,3,6)">LOTTO 6: <span
                class="text-l">{{stats.bando1Fase2_3_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,3,7)">LOTTO 7: <span
                class="text-l">{{stats.bando1Fase2_3_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>

    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #C4E4F5; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;font-size: 0.7rem;text-align: left;">2.4 In Attesa Infratel</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
          pTooltip="Apri pratiche in attesa infratel"
          (click)="openPraticheFase2(1,4)"
          >overview</i>
        </div>

        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_4}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,4,6)"
                  >LOTTO 6: <span
                class="text-l">{{stats.bando1Fase2_4_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,4,7)">LOTTO 7: <span
                class="text-l">{{stats.bando1Fase2_4_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #FFD0D0; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.5 Causa Cliente</div>
           <i class="material-symbols-outlined" style="font-size: 1.5rem; color: #1C56AC"
           [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
           [pTooltip]="isPresidioTIM ? '' : 'Apri Pratiche KO'"
           (click)="isPresidioTIM ? null : openPraticheFase2(1,5)"
            >person_alert</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_5}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 6'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,5,6)"
                >LOTTO 6: <span
                    class="text-l">{{stats.bando1Fase2_5_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
            [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
            tooltipPosition="top" 
            (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(1,5,7)">LOTTO 7: <span
                class="text-l">{{stats.bando1Fase2_5_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #D4F1DC; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.6 CUI Completato</div>
           <i  class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
            pTooltip="Apri Pratiche completate" tooltipPosition="top"
            (click)="openPraticheFase2(1,6)"
            >list_alt_check</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando1Fase2_6}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,6,6)">LOTTO 6: <span
                class="text-l">{{stats.bando1Fase2_6_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 6" tooltipPosition="top" (click)="openPraticheFase2PerLotto(1,6,7)">LOTTO 7: <span
                class="text-l">{{stats.bando1Fase2_6_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 border-bottom-1 opacity-50 "></div>

  <div class="col-12 mt-2 p-2 text-xl text-left font-['Poppins']"
    style="color: cornflowerblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <span class="text-xl text-left font-['Poppins'] mr-3 font-semibold" style="color: cornflowerblue;">Pratiche Bando 2</span>
      <div class="p-2" style="border-radius: 10px; background-color: #86a5e0; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" 
        style="color: #f9f9f9; font-size: small"
        [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
            [pTooltip]="isPresidioTIM ? '' : 'Mostra tutte le pratiche del bando 2'"
        (click)="isPresidioTIM ? null :openAllPraticheFase2(2)"
        pTooltip="Mostra tutte le pratiche" tooltipPosition="top"  >Totali: 
                 <span class="font-semibold" style="font-size: medium;">{{stats.bando2Fase2}}</span>
        </span>
      </div>
      <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;cursor: pointer;"
        [pTooltip]="isPresidioTIM ? 'Mostra le pratiche in carico al presidio' : 'Mostra le pratiche in lavorazione'"  
        tooltipPosition="top" (click)="openPraticheFase2InLavorazione(2)"> {{ isPresidioTIM ? 'In carico Presidio' : 'In lavorazione:' }} 
          <span class="font-semibold" style="font-size: medium;">{{stats.bando2Fase2InLavorazione}}</span>
        </span>
     </div>
    </div>
    <div class="flex justify-end md:justify-end">
      <button *ngIf="!isPM && !this.isImpresa && !this.isPresidioTIM && !this.isDirigenteFirmaPacchetti"
        pButton type="button" icon="pi pi-reply pi-cloud-upload"
        pTooltip="Aggiorna le pratiche verificate dal supporto" tooltipPosition="top"
        class="font-['Poppins'] mr-2"
        style="background-color:#ffffff; color: #3b6567; border-color: #3b6567; font-size: 13px;"
        label="Carica File TIM Support"
        (click)="importaEsitiSupporto()" [disabled]="isLoadingResults || isDemo"
      ></button>
      <button *ngIf="!isImpresa && !isPM && !this.isDirigenteFirmaPacchetti"
            pButton type="button" icon="pi pi-reply"
            pTooltip="Carica gli esiti della consegna ad Infratel" tooltipPosition="top"
            class="font-['Poppins'] "
            style="background-color:#ffffff; color: cornflowerblue; border-color: cornflowerblue; font-size: 13px;"
            label="Carica Esiti"
            (click)="importaEsitiConsegnaAdInfratel()" [disabled]="isLoading || isDemo"
        ></button>
    </div>
  </div>
  <div class="col-12 grid mt-1 mb-1">
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #F3FAFD; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.1 Senza documentazione</div>
          <i class="material-symbols-outlined" 
          style="font-size: 1.5rem; color: #1C56AC"
          [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
          (click)="isPresidioTIM ? null :openPraticheFase2(2,1)"  pTooltip="Apri Pratiche Senza Documentazione">insert_page_break</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_1}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 1'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,1,1)"
                >LOTTO 1: <span
                class="text-l">{{stats.bando2Fase2_1_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 5'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null : openPraticheFase2PerLotto(2,1,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_1_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,1,7)">LOTTO 7: <span
                class="text-l">{{stats.bando2Fase2_1_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 8'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,1,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_1_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;  font-size: 0.7rem;text-align: left;">2.2 Documentaz. incompleta</div>
          <i class="material-symbols-outlined" 
              style="font-size: 1.5rem; color: #1C56AC"
              [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
              (click)="isPresidioTIM ? null :openPraticheFase2(2,2)" 
              [pTooltip]="isPresidioTIM ? '' : 'Apri Pratiche con documentazione incompleta'"
              >inactive_order</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_2}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div  [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 1'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,2,1)">LOTTO 1: <span class="text-l">{{stats.bando2Fase2_2_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 5'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null : openPraticheFase2PerLotto(2,2,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_2_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,2,7)">LOTTO 7: <span
                  class="text-l">{{stats.bando2Fase2_2_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e5ea', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 8'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,2,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_2_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.3 Da Caricare</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
              (click)="openPraticheFase2(2,3)" pTooltip="Apri pratiche da caricare">upload_file</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_3}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,3,1)">LOTTO 1: <span
                class="text-l">{{stats.bando2Fase2_3_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,3,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_3_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,3,7)">LOTTO 7: <span
                class="text-l">{{stats.bando2Fase2_3_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#dde6e9', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,3,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_3_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>

    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #C4E4F5; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;font-size: 0.7rem;text-align: left;">2.4 In Attesa Infratel</div>
          <i class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
          (click)="openPraticheFase2(2,4)" pTooltip="Apri pratiche in attesa infratel">overview</i>
        </div>

        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_4}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,4,1)">LOTTO 1: <span
                class="text-l">{{stats.bando2Fase2_4_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,4,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_4_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,4,7)">LOTTO 7: <span
                class="text-l">{{stats.bando2Fase2_4_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d7e7ee', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,4,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_4_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #FFD0D0; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.5 Causa Cliente</div>

          <i class="material-symbols-outlined" 
          style="font-size: 1.5rem; color: #1C56AC"
          [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
          (click)="isPresidioTIM ? null :openPraticheFase2(2,5)"  pTooltip="Apri Pratiche KO">person_alert</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_5}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                  [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 1'"
                  tooltipPosition="top" 
                  (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,5,1)">LOTTO 1: <span
                class="text-l">{{stats.bando2Fase2_5_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 5'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null : openPraticheFase2PerLotto(2,5,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_5_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 7'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,5,7)">LOTTO 7: <span
                class="text-l">{{stats.bando2Fase2_5_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#efdbdb', 'color':'#1C56AC' }">
            <div [style.cursor]="isPresidioTIM ? 'not-allowed' : 'pointer'"
                [pTooltip]="isPresidioTIM ? '' : 'Apri pratiche lotto 8'"
                tooltipPosition="top" 
                (click)="isPresidioTIM ? null :openPraticheFase2PerLotto(2,5,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_5_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #D4F1DC; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; font-size: 0.7rem;text-align: left;">2.6 CUI Completato</div>

          <i class="material-symbols-outlined" style="font-size: 1.5rem; cursor: pointer; color: #1C56AC"
            (click)="openPraticheFase2(2,6)"  pTooltip="Apri pratiche completate" tooltipPosition="top" >list_alt_check</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{stats.bando2Fase2_6}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,6,1)">LOTTO 1: <span
                class="text-l">{{stats.bando2Fase2_6_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,6,5)">LOTTO 5: <span
                class="text-l">{{stats.bando2Fase2_6_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,6,7)">LOTTO 7: <span
                class="text-l">{{stats.bando2Fase2_6_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#d8e8dc', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheFase2PerLotto(2,6,8)">LOTTO 8: <span
                class="text-l">{{stats.bando2Fase2_6_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
  </div>
</div>